/* eslint-disable no-nested-ternary */
/** @jsx jsx */
import React, { useEffect } from 'react';

import FormTitle from 'components/atoms/Form/FormTitle';
import { css, jsx } from '@emotion/core';
import VerticalLabelSelectForm from 'components/molecules/VerticalLabelSelectForm';
import RadioSelectForm from 'components/molecules/RadioSelectForm';
import FlexBox from 'components/atoms/FlexBox';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import FormPadding from 'components/atoms/Form/FormPadding';

const EmploymentGPSStampSettings: React.FC<{
  formik: any,
}> = ({
  formik
}) => {
    const recessTimeAlertItems = [];
    const recessTimeAlert = 3;
    for (let i = 0; i < recessTimeAlert;) {
      recessTimeAlertItems.push(i);
      i += 1;
    }

    return (
      <React.Fragment>
        <FormTitle title="ログイン後の打刻方法設定" bold={true} customStyle={css({marginLeft: '0', padding: '16px 0'})}/>
        <FlexBox>
          <FlexBoxItem basis="50%">
            <FormPadding customStyle={css({paddingLeft: 0})}>
              <VerticalLabelSelectForm
                label="GPS打刻設定"
                name="useGpsStamp"
                options={[
                  {
                    label: '使用しない',
                    value: '0'
                  },
                  {
                    label: '使用する',
                    value: '1'
                  }
                ]}
                value={String(formik.values.useGpsStamp)}
                setValue={(val) => formik.setFieldValue('useGpsStamp', val)}
              />
            </FormPadding>

            {/* <VerticalLabelSelectForm
              label="出社打刻をオフィスとテレワークで区別して打刻する"
              name="isRemote"
              options={[
                {
                  label: 'しない',
                  value: 'false',
                },
                {
                  label: 'する',
                  value: 'true',
                },
              ]}
              value={String(formik.values.isRemote)}
              setValue={(val) => {
                formik.setFieldValue('isRemote', val === 'true')
              }}
            /> */}
            
            <FormPadding customStyle={css({paddingLeft: 0})}>
              <VerticalLabelSelectForm
                label="ID打刻設定"
                name="useInsideLoginBarcodeStamp"
                options={[
                  {
                    label: '使用しない',
                    value: '0'
                  },
                  {
                    label: '使用する',
                    value: '1'
                  }
                ]}
                value={String(formik.values.useInsideLoginBarcodeStamp)}
                setValue={(val) => formik.setFieldValue('useInsideLoginBarcodeStamp', val)}
              />
            </FormPadding>

            <FormPadding customStyle={css({paddingLeft: 0})}>
              <VerticalLabelSelectForm
                label="顔認証打刻設定"
                name="useInsideLoginFaceRecorderStamp"
                options={[
                  {
                    label: '使用しない',
                    value: '0'
                  },
                  {
                    label: '使用する',
                    value: '1'
                  }
                ]}
                value={String(formik.values.useInsideLoginFaceRecorderStamp)}
                setValue={(val) => formik.setFieldValue('useInsideLoginFaceRecorderStamp', val)}
              />
            </FormPadding>
          </FlexBoxItem>
        </FlexBox>
        <FlexBox>
          <FlexBoxItem basis="50%">
            <FormTitle
              title="オフィス・テレワークの区別"
              bold={true}
              customStyle={css({paddingLeft: '0'})}
            />
            <RadioSelectForm
              label="出社打刻をオフィスとテレワークで区別して打刻する"
              name="isRemote"
              items={[
                {
                  label: 'しない',
                  value: 'false',
                },
                {
                  label: 'する',
                  value: 'true',
                },
              ]}
              value={String(formik.values.isRemote)}
              setValue={(e) => {
                formik.setFieldValue('isRemote', e.target.value === 'true');
              }}
            />
          </FlexBoxItem>
        </FlexBox>
      </React.Fragment>
    );
  };

export default EmploymentGPSStampSettings;
